const truncateWords = (value: string, amountWords = 30, tail = '') => {
  const words = value.split(' ');
  if (amountWords >= words.length) return value;
  const truncatedWords = words.slice(0, amountWords);
  return `${truncatedWords.join(' ')}${tail}`;
};

export default truncateWords;
